<template>
  <div>
    {{ users.toLocaleString() }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: 0
    };
  },
  props: {
    location: {
      type: Object,
      required: true
    },
    radius: {
      type: Number,
      required: true
    }
  },
  // watch: {
  //   location: {
  //     immediate: false,
  //     deep: true,
  //     handler() {
  //       this.attempts = 0;
  //       this.updateUsers();
  //     }
  //   },
  //   radius: {
  //     immediate: false,
  //     deep: true,
  //     handler() {
  //       this.attempts = 0;
  //       this.updateUsers();
  //     }
  //   }
  // },
  created() {
    this.updateUsers();
  },
  methods: {
    updateUsers() {
      this.$http
        .post(
          "/reach-estimates/all",
          {
            latitude: this.location.lat,
            longitude: this.location.lng,
            /* eslint-disable */
            targeting_radius: this.radius
            /* eslint-enable */
          },
          { retry: 5, retryDelay: 250 }
        )
        .then(response => {
          this.users = response.data.users_upper_bound;
          this.$emit("loaded");
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
